export default __webpack_public_path__ + "58d634e.png";